import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';

@Injectable({ providedIn: 'root' })
export class ApiDataWeatherConditionService {
  constructor(private _api: ApiService) {}

  get(id: number | string) {
    return this._api.get('data-weather-condition/get/id/' + id);
  }

  list(data: any = {}) {
    return this._api.post('data-weather-condition/list', data);
  }

  create(data: any) {
    return this._api.post('data-weather-condition/create', data);
  }

  update(data: any) {
    return this._api.post('data-weather-condition/update', data);
  }

  remove(id: number) {
    return this._api.post('data-weather-condition/remove/id/' + id);
  }
}
